module.exports = __webpack_public_path__ + "img/cast_partners_photo.fbe5f52c.png";